module.exports = "https://cdn.redage.net/src/views/player/help/images/lawn2.jpg";